import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { CapacitorHttp } from "@capacitor/core";

const SignIn = () => {
  const navigate = useNavigate();
  const [resetEmail, setResetEmail] = useState("");

  const onNgNhpTextClick = useCallback(() => {
    navigate("/21-login");
  }, [navigate]);

  const handleResetPassword = async () => {
    if (!resetEmail) {
      alert("📧 Vui lòng nhập email để khôi phục mật khẩu!");
      return;
    }

    try {
      const resp = await CapacitorHttp.post({
        url: `https://identitytoolkit.googleapis.com/v1/accounts:sendOobCode?key=AIzaSyCNSd_Oe15e__CaaFw0HRfhPBMK7wwH7jY`,
        headers: { "Content-Type": "application/json" },
        data: {
          requestType: "PASSWORD_RESET",
          email: resetEmail,
        },
      });

      if (resp.status === 200) {
        alert("✅ Đã gửi email đặt lại mật khẩu!");
      } else {
        alert("❌ Lỗi gửi email: " + (resp.data?.error?.message || "Không rõ lỗi"));
      }
    } catch (err) {
      console.error("❌ Lỗi gửi mật khẩu:", err);
      alert("❌ Không gửi được email. Vui lòng thử lại.");
    }
  };

  return (
    <div className="w-full bg-light-primary-key-background flex flex-col gap-6 p-10 text-base font-text-regular-lowercase">
      <div className="font-medium cursor-pointer" onClick={onNgNhpTextClick}>
        {`<  Đăng nhập`}
      </div>

      <h1 className="text-2xl font-semibold text-dark-text">Quên mật khẩu</h1>

      <input
        type="email"
        placeholder="Nhập email của bạn"
        value={resetEmail}
        onChange={(e) => setResetEmail(e.target.value)}
        className="p-3 rounded-full border border-gray-300"
      />

      <button
        onClick={handleResetPassword}
        className="bg-gradient-to-r from-pink-400 to-orange-300 text-white font-semibold rounded-full px-6 py-3"
      >
        Gửi email đặt lại mật khẩu
      </button>
    </div>
  );
};

export default SignIn;
